(function () {
  if (window.__bonkFloatingPolish) return;
  window.__bonkFloatingPolish = true;

  var STYLE_ID = 'bonk-floating-polish-style';
  var ACTIVE_CLASS = 'bonk-app-modal-active';

  function installStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      'html.' + ACTIVE_CLASS + ' #ShopifyChat,',
      'html.' + ACTIVE_CLASS + ' #smile-ui-lite-launcher-frame-container,',
      'html.' + ACTIVE_CLASS + ' #google-merchantwidget-iframe-wrapper,',
      'html.' + ACTIVE_CLASS + ' [id^="___ratingbadge_"]{',
      'opacity:0!important;',
      'pointer-events:none!important;',
      'transform:translateY(12px)!important;',
      '}'
    ].join('');

    document.head.appendChild(style);
  }

  function isVisibleAppModal(element) {
    if (!(element instanceof HTMLElement)) return false;
    if (element.matches('cart-drawer, pickup-availability-drawer, .drawer')) return false;

    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    if (style.position !== 'fixed') return false;

    var zIndex = parseInt(style.zIndex, 10);
    if (!Number.isFinite(zIndex) || zIndex < 1000) return false;

    var rect = element.getBoundingClientRect();
    if (rect.width < window.innerWidth * 0.65) return false;
    if (rect.height < window.innerHeight * 0.35) return false;
    if (rect.right < window.innerWidth * 0.75) return false;
    if (rect.bottom < window.innerHeight * 0.55) return false;

    return true;
  }

  function updateState() {
    var hasModal = Array.prototype.some.call(document.body ? document.body.querySelectorAll('*') : [], isVisibleAppModal);
    document.documentElement.classList.toggle(ACTIVE_CLASS, hasModal);
  }

  function scheduleUpdate() {
    window.requestAnimationFrame(updateState);
  }

  function start() {
    installStyles();
    updateState();

    var observer = new MutationObserver(scheduleUpdate);
    observer.observe(document.documentElement, {
      attributes: true,
      childList: true,
      subtree: true
    });

    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.setTimeout(updateState, 1000);
    window.setTimeout(updateState, 3000);
    window.setTimeout(updateState, 7000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
